/**
 * โหลด Maps JavaScript API แบบเดียวกันทั้งโปรเจกต์ (เหมือน AdminMonitoringMap / CallRider)
 * — กันสคริปต์ซ้ำเมื่อหลายคอมโพเนนต์เปิดในหน้าเดียวกัน
 */
let loadPromise = null;

function normalizeApiKey() {
  return String(process.env.VUE_APP_GOOGLE_MAPS_API_KEY || "")
    .replace(/['"]+/g, "")
    .trim();
}

export function loadGoogleMapsScript() {
  if (typeof window !== "undefined" && window.google && window.google.maps) {
    return Promise.resolve();
  }
  if (loadPromise) {
    return loadPromise;
  }

  loadPromise = new Promise((resolve, reject) => {
    const finishOk = () => {
      if (window.google && window.google.maps) {
        resolve();
      } else {
        reject(new Error("Google Maps API ไม่พร้อม"));
      }
    };

    const apiKey = normalizeApiKey();
    const script = document.createElement("script");
    script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places&language=th`;
    script.async = true;
    script.defer = true;
    script.dataset.elGoogleMaps = "1";
    script.onload = finishOk;
    script.onerror = () => reject(new Error("โหลดสคริปต์ Google Maps ไม่สำเร็จ"));
    document.head.appendChild(script);
  });

  return loadPromise;
}
